<script lang="ts">
  import TooltipIcon from '$icons/TooltipIcon.svelte';

  export let position:
    | 'left'
    | 'right'
    | 'bottom-center'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-center'
    | 'top-left'
    | 'top-right' = 'top-center';
  export let tooltipContent: string;
  export let disabled = false;
</script>

<div class="tooltip {position}" class:disabled>
  <div class="tooltip-trigger">
    <slot />
  </div>
  {#if !disabled}
    <div class="tooltiptext">
      <div class="max-h-[100px] w-max max-w-xs overflow-auto">
        {tooltipContent}
      </div>
      <div class="break-icon {position}">
        <TooltipIcon />
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  /* Tooltip container styles */
  .tooltip {
    @apply relative inline-block;
  }

  .tooltip-trigger {
    @apply inline-block;
  }

  /* Tooltip text styles */
  .tooltiptext {
    @apply border-gray-dark-4 bg-gray-dark-4 invisible border;
    @apply text-gray-dark-12 whitespace-pre-line text-sm leading-5;
    @apply absolute z-50;
    @apply rounded-md p-2;
    @apply opacity-0 transition-opacity duration-300;
    box-shadow: 0px 1px 3px 0px rgba(129, 83, 83, 0.04);
  }

  /* Change hover target from .tooltip to .tooltip-trigger */
  .tooltip-trigger:hover ~ .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .break-icon {
    @apply absolute z-50;
  }

  /* Positioning for left tooltip */
  .tooltip.left .tooltiptext {
    @apply right-[125%] top-1/2 -translate-y-1/2;
  }

  .break-icon.left {
    @apply -right-3.5 top-[calc(50%_-_4.5px)] rotate-90;
  }

  /* Positioning for right tooltip */
  .tooltip.right .tooltiptext {
    @apply left-[125%] top-1/2 -translate-y-1/2;
  }

  .break-icon.right {
    @apply -left-3.5 top-[calc(50%_-_4.5px)] -rotate-90;
  }

  /* Positioning for bottom-center tooltip */
  .tooltip.bottom-center .tooltiptext {
    @apply left-1/2 top-[125%] -translate-x-1/2;
  }

  .break-icon.bottom-center {
    @apply -top-2 right-[calc(50%_-_9px)];
  }

  /* Positioning for bottom-left tooltip */
  .tooltip.bottom-left .tooltiptext {
    @apply right-0 top-[125%];
  }

  .break-icon.bottom-left {
    @apply -top-2 right-2.5;
  }

  /* Positioning for bottom-right tooltip */
  .tooltip.bottom-right .tooltiptext {
    @apply left-0 top-[125%];
  }

  .break-icon.bottom-right {
    @apply -top-2 left-2.5;
  }

  /* Positioning for top-center tooltip */
  .tooltip.top-center .tooltiptext {
    @apply bottom-[125%] left-1/2 -translate-x-1/2;
  }

  .break-icon.top-center {
    @apply -bottom-2 right-[calc(50%_-_9px)] rotate-180;
  }

  /* Positioning for top-left tooltip */
  .tooltip.top-left .tooltiptext {
    @apply bottom-[125%] right-0;
  }

  .break-icon.top-left {
    @apply -bottom-2 right-2.5 rotate-180;
  }

  /* Positioning for top-right tooltip */
  .tooltip.top-right .tooltiptext {
    @apply bottom-[125%] left-0;
  }

  .break-icon.top-right {
    @apply -bottom-2 left-2.5 rotate-180;
  }

  /* Prevent tooltip from showing when disabled */
  .tooltip.disabled .tooltip-trigger:hover ~ .tooltiptext {
    visibility: hidden;
    opacity: 0;
  }
</style>
